import { api } from '@/utils/api'
import alert from '../helpers/alert'

const state = () => {
  return {
    btnSave: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnCancel: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnDraft: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnItemSave: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnReject: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnDelete: {
      disabled: false,
      loading: false,
      hide: true
    },
    tableTab: {
      label: null,
      value: null,
      url: null,
      currentUrl: null,
      page: 1
    },
    search: {
      field: null,
      type: 'like',
      value: null,
      companySelected: [],
      statusSelected: []
    },
    isClaim: false,
    isApprove: false,
    countMyDoc: 0,
    files: [],
    documentPath: null,
    documentPathText: null,
    memo: [],
    orderType: [],
    orderTypeDefault: null,
    docStatusOption: [],
    filterOption: [],
    materialFilterOption: [],
    approveOption: [],
    paymentTermAll: [],
    shippingRecipientOption: [],
    materialVendors: []
  }
}

const getters = {
  getFileAttach(state) {
    return state.files.map(item => {
      return {
        id: item.id,
        path_file: item.path_file,
        path_thumbnail: item.path_thumbnail,
        url_file: item.url_file,
        url_thumbnail: item.url_thumbnail
      }
    })
  }
}

const mutations = {
  initBtn(state) {
    state.btnSave = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnCancel = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnDraft = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnItemSave = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnReject = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnDelete = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.isClaim = false
    state.isApprove = false
    // state.docStatusOption = []
    // state.filterOption = []
    state.countMyDoc = 0
    state.files = []
    state.documentPath = null
    state.documentPathText = null
    state.paymentTermAll = []
    state.shippingRecipientOption = []
  },
  setBtnActive(state, data) {
    state[data.type].loading = !state[data.type].loading
    state[data.type].disabled = !state[data.type].disabled
  },
  setBtnActiveFix(state, data) {
    state[data.type].loading = data.status
    state[data.type].disabled = data.status
  },
  setBtn(state, data) {
    state[data.type][data.value] = !state[data.type][data.value]
  },
  setFile(state, data) {
    state.files.push(data)
  },
  removeFile(state, id) {
    const newFile = state.files.filter(item => {
      return item.id !== id
    })
    state.files = newFile
  },
  setDocumentPath(state, data) {
    state.documentPath = data
  },
  setDocumentPathText(state, data) {
    state.documentPathText = data
  },
  setDocStatusOption(state, data) {
    state.docStatusOption = data
  },
  setFilterOption(state, data) {
    state.filterOption = data
  },
  setMaterialFilterOption(state, data) {
    state.materialFilterOption = data
  },
  setCountMyDoc(state, count) {
    state.countMyDoc = count
  },
  setTableTab(state, tab) {
    state.tableTab.label = tab.label
    state.tableTab.value = tab.value
    state.tableTab.url = tab.url
    state.tableTab.currentUrl = tab.url
  },
  setCompanyAndStatus(state, data) {
    state.search.companySelected = data.companySelected
    state.search.statusSelected = data.statusSelected
    state.search.field = data.field
    state.search.value = data.value
  },
  updateTableTab(state, tab) {
    state.tableTab.currentUrl = tab.currentUrl
    state.tableTab.page = tab.page
  },
  clearTableTab(state, data) {
    state.search.companySelected = []
    state.search.statusSelected = []
    state.search.field = data.field
    state.search.value = null

    state.tableTab.currentUrl = state.tableTab.url
    state.tableTab.page = 1
  },
  clearSelectedCompanyAndStatus(state) {
    state.search.companySelected = []
    state.search.statusSelected = []
  },
  setMemo(state, data) {
    state.memo = data
  },
  setApproveOption(state, data) {
    state.approveOption = data
  },
  setIsClaim(state, data) {
    state.isClaim = data
  },
  setIsApprove(state, data) {
    state.isApprove = data
  },
  setOrderType(state, data) {
    state.orderType = data
  },
  setOrderTypeDefault(state, data) {
    state.orderTypeDefault = data
  },
  pustEmployee(stete, data) {
    // console.log('push:', state, this.state)
    const c = this.state.global.employee.find(
      item => item.employee_id == data.employee_id
    )
    if (c === undefined) {
      this.state.global.employee.push({
        employee_id: data.employee_id,
        employee_image: data.employee_image,
        // employee_image:
        //   'https://nationhouse.nationgroup.com/helpers/showpic.php?empid=' +
        //   data.employee_id,
        fullname_th: data.fullname_th,
        bu_no: data.bu_no,
        bu_name: data.bu_name,
        telephone: data.telephone,
        is_role_account: false,
        is_role_it: false,
        is_role_purchase: false
      })
    }
  },
  setPaymentTermAll(state, data) {
    state.paymentTermAll = data
  },
  setShippingRecipientList(state, data) {
    state.shippingRecipientOption = data
  },
  setMaterialVendors(state, data) {
    state.materialVendors.push(data)
  }
}

const actions = {
  async loadDocumentPath({ commit }, payload) {
    // let urlApi = null
    // if (payload.specialPath === null) {
    //   urlApi = `/hr/employee/documentPath?doc_type=OF&comp_no=${payload.compNo}&employee_id=${payload.employeeId}`
    // } else {
    const urlApi = `/hr/employee/documentPath?doc_type=OF&special_path=${payload.specialPath}&comp_no=${payload.compNo}&employee_id=${payload.employeeId}`
    // }

    await api.get(urlApi).then(res => {
      if (res.code == 200) {
        commit('setDocumentPath', res.data.documentPath)
        commit('setDocumentPathText', res.data.documentPathText)
      }
    })
  },
  async loadDocStatusOption({ commit, state, rootState }) {
    if (state.docStatusOption.length == 0) {
      await api
        .get(
          `/preorder/of/getOptionDocMenu?showTabMonitor=${rootState.auth.info.showTabMonitor}&roleCode=${rootState.auth.info.roleCode}`
        )
        .then(res => {
          if (res.code == 200) {
            commit('setDocStatusOption', res.data)
            commit('setTableTab', res.data[0])
          }
        })
    }
  },
  async loadFilterOption({ commit, state }) {
    if (state.filterOption.length == 0) {
      await api.get('/preorder/of/allOption').then(res => {
        commit('setFilterOption', res.data)
      })
    }
  },
  async loadMaterialFilterOption({ commit, state }) {
    if (state.filterOption.length == 0) {
      await api.get('/procurement/materials/getAllOption').then(res => {
        commit('setMaterialFilterOption', res.data)
      })
    }
  },
  async loadCountMyDoc({ commit }, employeeId) {
    await api.get(`/preorder/of/countDocWait/${employeeId}`).then(async res => {
      if (res.code == 200) {
        commit('setCountMyDoc', res.data.doc_wait)
        commit(
          'global/setDocWaitType',
          { type: 'pr', value: res.data.doc_wait },
          { root: true }
        )
      }
    })
  },
  async loadMemo({ commit }, data) {
    await api
      .get(`/memo/memo/getMyDocForUse?group_month=true&back_month=${process.env.VUE_APP_API_MEMO_BACK_MONTH}`)
      .then(res => {
        if (res.code == 200) {
          commit('setMemo', res.data)
        }
      })
  },
  async loadApproveOption({ commit, state }, data) {
    await api
      .get(
        `/preorder/of/getOptionApproveResult?employeeId=${data.employeeID}&docId=${data.docID}`
      )
      .then(res => {
        if (res.code == 200) {
          commit('setApproveOption', res.data)
        }
      })
  },
  async approveClaim({ commit }, data) {
    return await api
      .post('/preorder/of/claim', data)
      .then(res => {
        if (res.code == 200) {
          commit('setIsClaim', false)
          alert.success()
          return res.data.employee_id
        } else {
          alert.error(res.message)
          return false
        }
        // return { code:// res.code, message: res.message }
      })
      .catch(e => {
        alert.error(e.message)
        return false
      })
  },
  async approveOF({ commit }, data) {
    try {
      return await api.post('/preorder/of/approve', data).then(res => {
        if (res.code == 200) {
          commit('setIsApprove', true)
          alert.success()
          return true
        } else {
          alert.error(res.message)
          return false
        }
      })
    } catch (e) {
      console.log('e: ', e.message)
      return false
    }
  },
  async loadOrderType({ commit }, data) {
    // console.log('load order type: ', data)
    return await api
      .get(
        `/procurement/userProfile/getOrderTypeOfUser?comp_no=${data.compNo}&employee_id=${data.employeeId}`
      )
      .then(res => {
        if (res.code == 200) {
          commit('setOrderType', res.data)
          commit('setOrderTypeDefault', res.default)
          return true
        } else {
          alert.error(res.message)
          return false
        }
      })
  },
  async loadShippingRecipientList({ commit, state }, payload) {
    await api
      .get(`/preorder/of/getShippingRecipientList?compNo=${payload.compNo}`)
      .then(res => {
        if (res.code == 200) {
          commit('setShippingRecipientList', res.data)
        } else {
          alert.error(res.message)
        }
      })
      .catch(e => {
        console.log('error service po: ', e)
      })
  },
  setTableTab({ commit }, tab) {
    commit('setTableTab', tab)
  },
  async loadEmployeeById({ commit }, data) {
    const c = await this.state.global.employee.find(
      item => item.employee_id == data.employee_id
    )
    if (c === undefined) {
      await api.get(`/hr/employee/syncById/${data.employeId}`).then(res => {
        commit('pustEmployee', res.data[0])
      })
    }
  },
  async loadPaymentTerm({ commit }) {
    await api.get('/admin/paymentTerm/all').then(res => {
      commit('setPaymentTermAll', res.data.data)
    })
  },
  async getMaterialVendor({ commit, state }, data) {
    const materialVendor = state.materialVendors.find(
      r =>
        r.material_code == data.materialCode && r.vendor_code == data.vendorCode
    )
    // console.log('materialVendor: ', materialVendor)
    if (materialVendor) {
      return materialVendor
    }
    return await api
      .get(
        `/preorder/materialVendor/getOne?material_code=${data.materialCode}&vendor_code=${data.vendorCode}`
      )
      .then(res => {
        if (res.data !== null) {
          commit('setMaterialVendors', res.data)
          return res.data
        } else {
          return null
        }
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
